/**
 * @file headChatBot
 */

import axiosInstance from './axiosInstance';

// 获取新 session id
export const getSessionIdApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/sessions`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取 session 列表
export const getSessionListApi = async () => {
  try {
    const response = await axiosInstance.get(`/v1/chatbot/agent/sessions`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取 session 详情
export const getSessionMessageApi = async (sessionId: string) => {
  try {
    const response = await axiosInstance.get(`/v1/chatbot/agent/sessions/${sessionId}`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 编辑 session 数据
export const editSessionDataApi = async (sessionId: string, data: any) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/sessions/${sessionId}`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};


// 赞踩 + 赞踩弹窗
export const feedbackSessionApi = async (sessionId: string, data: { feedback: { like?: Boolean, dislike?: Boolean, reason?: string }, messageId: string }) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/sessions/${sessionId}/feedback`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 删除 + 删除弹窗
export const deleteSessionApi = async (sessionId: string) => {
  try {
    const response = await axiosInstance.delete(`/v1/chatbot/agent/sessions/${sessionId}`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};


// 获取图片上传地址
export const getUploadUrlApi = async (data: { keys: string[] }) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/batchUploadUrl`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

// 创建 campaign
export const createCampaignByAIApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/ads/campaign/v2/createByAI`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}